import React, { useState } from 'react';
import { Col, Form } from "react-bootstrap";
import { Droppable, Draggable } from 'react-beautiful-dnd';

function DishesMenu({ dishes, weeks }) {
  const [searchTerm, setSearchTerm] = useState('');

  // Filter dishes based on search term
  const filteredDishes = dishes?.filter(dish => 
    dish.dishName.toLowerCase().includes(searchTerm.toLowerCase())
  ) || [];

  // Separate filtered dishes into main dishes and desserts
  const mainDishes = filteredDishes.filter(dish => !dish.isDessert) || [];
  const desserts = filteredDishes.filter(dish => dish.isDessert) || [];

  return (
    <Col md={4} xs={12} className="mb-3">
      {weeks.length > 0 && (
        <div className="dishes-menu">
            <h2>Maträtter</h2>
          {/* Search Bar */}
          <Form.Group className="mb-3">
            <Form.Control
              type="text"
              placeholder="Sök maträtter..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Form.Group>

          {/* Main Dishes Section */}
          <Droppable droppableId="dishesMenu" isDropDisabled={true}>
            {(provided) => (
              <div ref={provided.innerRef} {...provided.droppableProps} className="dishes-list">
                {mainDishes.length > 0 ? (
                  mainDishes.map((dish, index) => (
                    <Draggable key={dish._id} draggableId={dish.dishName} index={index}>
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          className="dish-item"
                        >
                          {dish?.dishName}
                        </div>
                      )}
                    </Draggable>
                  ))
                ) : (
                  <div>Inga maträtter matchar sökningen</div>
                )}
                {provided.placeholder}
              </div>
            )}
          </Droppable>

          {/* Desserts Section */}
          {desserts.length > 0 && (
            <>
              <h2>Efterrätter</h2>
              <Droppable droppableId="dessertsMenu">
                {(provided) => (
                  <div ref={provided.innerRef} {...provided.droppableProps} className="dishes-list">
                    {desserts.map((dish, index) => (
                      <Draggable key={dish._id} draggableId={dish.dishName} index={index}>
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            className="dish-item"
                            >
                            {dish?.dishName}
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </>
          )}
        </div>
      )}
    </Col>
  );
}

export default DishesMenu;